import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./CheckoutI9.css";

const LOGO_URL =
  "https://welaunchyou.com.br/crm-wly/static/media/norea.8d2d0d0d90d46fd1f46e.png";
const DASH_IMG_URL = "/crm-wly/uploads/logos/Tela-Norea-Dashboard.png";

export default function CheckoutI9() {
  const navigate = useNavigate();

  // ---------------- UI STATE ----------------
  const [step, setStep] = useState("form"); // form | paying | success
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [copied, setCopied] = useState(false);
  const [acceptedLGPD, setAcceptedLGPD] = useState(false);


  // ---------------- FORM ----------------
  const [formData, setFormData] = useState({
    nome: "",
    nome_empresa: "",
    responsavel: "",
    telefone: "",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    email: "",
    senha: "",
    senha2: "", // confirmação
    cpf_cnpj: ""
  });

  // ---------------- PIX ----------------
  const [pix, setPix] = useState({ id: null, qrCode: "", payload: "" });
  const pollRef = useRef(null);

  useEffect(() => {
    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, []);

  const onChange = (e) =>
    setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));

  // CEP -> ViaCEP
  const onCepBlur = async () => {
    const cepDigits = (formData.cep || "").replace(/\D/g, "");
    if (cepDigits.length !== 8) return;
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cepDigits}/json/`);
      const data = await res.json();
      if (data?.erro) return;
      setFormData((s) => ({
        ...s,
        logradouro: data.logradouro || s.logradouro,
        bairro: data.bairro || s.bairro,
        cidade: data.localidade || s.cidade,
        estado: data.uf || s.estado
      }));
    } catch {
      // silencioso
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(pix.payload || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      const ta = document.getElementById("pix-copy");
      if (ta) {
        ta.focus();
        ta.select();
      }
    }
  };

  const normalizeQr = (raw) => {
    if (!raw) return "";
    if (raw.startsWith("data:image")) return raw;
    return `data:image/png;base64,${raw}`;
  };

  const pagar = async () => {
    setErrMsg("");
    // valida confirmação de senha
    if ((formData.senha || "") !== (formData.senha2 || "")) {
      setErrMsg("As senhas não conferem. Verifique e tente novamente.");

    if (!acceptedLGPD) {
    setErrMsg("É necessário aceitar a Política de Privacidade (LGPD) para continuar.");
     return;
}
    }

    setLoading(true);
    setStep("form");

    try {
      // 1) Cria usuário no CRM + Asaas
      const u = await axios.post(
        "https://welaunchyou.com.br/crm-wly/api/financeiro/criar_usuario_checkout.php",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (!u.data?.id_cliente_asaas) {
        throw new Error("Não foi possível criar o cliente no Asaas.");
      }

      // 2) Cria cobrança PIX (o PHP já atualiza a fatura e retorna os campos do Pix)
      const c = await axios.post(
        "https://welaunchyou.com.br/crm-wly/api/financeiro/checkout_i9.php",
        {
          customerId: u.data.id_cliente_asaas,
          usuario_id: u.data.usuario_id,
          cliente_nome: formData.nome,
          fatura_id: u.data.fatura_id
        },
        { headers: { "Content-Type": "application/json" } }
      );

      const payment = c.data?.payment ?? c.data;
      if (!payment?.id) throw new Error("Cobrança Pix não retornou um ID.");

      setPix({
        id: payment.id,
        qrCode: normalizeQr(payment.pixQrCodeImage),
        payload: payment.pixCopyPaste || payment.pixQrCode || payment.qrCode || ""
      });

      setStep("paying");

      // 3) Polling (checa status via backend)
      if (pollRef.current) clearInterval(pollRef.current);
      pollRef.current = setInterval(async () => {
        try {
          const statusRes = await axios.post(
            "https://welaunchyou.com.br/crm-wly/api/financeiro/checkout_i9.php",
            { action: "status", id: payment.id },
            { headers: { "Content-Type": "application/json" } }
          );
          const s = statusRes.data?.status;
          if (s === "RECEIVED" || s === "CONFIRMED") {
            clearInterval(pollRef.current);
            pollRef.current = null;
            navigate("/login");
            setStep("success");
          }
        } catch {}
      }, 5000);
    } catch (err) {
      console.error(err.response?.data || err);
      setErrMsg(
        err.response?.data?.error ||
          err.response?.data?.message ||
          err.message ||
          "Erro ao processar checkout."
      );
      setStep("form");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="checkout-page two-col">
      {/* COLUNA ESQUERDA (herói) */}
      <aside className="left-hero">
        <div className="brand-stack">
          <img src={LOGO_URL} className="brand-logo-xl" alt="Nórea CRM" />
          <h1 className="hero-headline">Checkout I9</h1>
          <p className="hero-subcopy">
            <strong>Página de pagamento</strong> para acesso ao{" "}
            <strong>Nórea CRM</strong>. Após a confirmação do Pix, seu acesso é{" "}
            <strong>imediato</strong> a toda a plataforma.
          </p>

          <div className="price-chip big" aria-label="Valor do plano">
            <span>Valor</span>
            <strong>R$ 297,00</strong>
            <span style={{ color: "white" }}>/mês</span>
          </div>
        </div>

        <figure className="promo-figure" aria-hidden="true">
          <img src={DASH_IMG_URL} alt="" className="promo-image" loading="lazy" />
          <span className="promo-outline" />
        </figure>
      </aside>

      {/* COLUNA DIREITA (form / pix) */}
      <div className="checkout-card right-pane">
        
        {step !== "paying" && step !== "success" && (
          <form
            className="checkout-form"
            onSubmit={(e) => {
              e.preventDefault();
              pagar();
            }}
          >
            <div className="grid">
              <div className="field">
                <label>Nome completo*</label>
                <input name="nome" value={formData.nome} onChange={onChange} required />
              </div>
              <div className="field">
                <label>Nome da empresa</label>
                <input name="nome_empresa" value={formData.nome_empresa} onChange={onChange} />
              </div>

              <div className="field">
                <label>Responsável</label>
                <input name="responsavel" value={formData.responsavel} onChange={onChange} />
              </div>
              <div className="field">
                <label>Telefone*</label>
                <input name="telefone" value={formData.telefone} onChange={onChange} required />
              </div>

              {/* CEP primeiro */}
              <div className="field small">
                <label>CEP*</label>
                <input
                  name="cep"
                  value={formData.cep}
                  onChange={onChange}
                  onBlur={onCepBlur}
                  required
                />
              </div>
              <div className="field">
                <label>Endereço*</label>
                <input
                  name="logradouro"
                  value={formData.logradouro}
                  onChange={onChange}
                  required
                />
              </div>
              <div className="field small">
                <label>Número*</label>
                <input name="numero" value={formData.numero} onChange={onChange} required />
              </div>
              <div className="field">
                <label>Complemento</label>
                <input name="complemento" value={formData.complemento} onChange={onChange} />
              </div>
              <div className="field">
                <label>Bairro*</label>
                <input name="bairro" value={formData.bairro} onChange={onChange} required />
              </div>
              <div className="field">
                <label>Cidade*</label>
                <input name="cidade" value={formData.cidade} onChange={onChange} required />
              </div>
              <div className="field tiny">
                <label>UF*</label>
                <input name="estado" value={formData.estado} onChange={onChange} required />
              </div>

              <div className="field">
                <label>E-mail*</label>
                <input name="email" type="email" value={formData.email} onChange={onChange} required />
              </div>
              <div className="field">
                <label>Senha*</label>
                <input name="senha" type="password" value={formData.senha} onChange={onChange} required />
              </div>
              <div className="field">
                <label>Confirmar senha*</label>
                <input name="senha2" type="password" value={formData.senha2} onChange={onChange} required />
              </div>

              <div className="field">
                <label>CPF/CNPJ*</label>
                <input name="cpf_cnpj" value={formData.cpf_cnpj} onChange={onChange} required />
              </div>
            </div>
            {errMsg && <div className="alert alert-error">{errMsg}</div>}

            <div className="consent">
              <label className="consent__label">
                <input
                  type="checkbox"
                  checked={acceptedLGPD}
                  onChange={(e) => setAcceptedLGPD(e.target.checked)}
                />
                <span>
                  Li e concordo com a{" "}
                  <a
                    href="/crm-wly/politica-privacidade"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política de Privacidade de Dados (LGPD)
                  </a>.
                </span>
              </label>
            </div>

            <div className="actions">
              <button type="submit" className="btn btn-primary" disabled={loading || !acceptedLGPD}>
                {loading ? "Processando..." : "Gerar Pix"}
              </button>

            </div>
          </form>
        )}

        {step === "paying" && (
  <div className="pix-box">
    <h3>Escaneie o QR Code abaixo:</h3>

    <div className="qr-wrapper">
      {pix.qrCode ? (
        <img className="qr-image" src={pix.qrCode} alt="QR Code Pix" draggable={false} />
      ) : (
        <div className="qr-skeleton">Gerando QR Code…</div>
      )}
    </div>

    <div className="copy-box">
      <label>Código copia e cola:</label>

      {/* textarea sozinho */}
      <div className="copy-row">
        <textarea
          id="pix-copy"
          readOnly
          value={pix.payload}
          placeholder="Aguardando dados do Pix…"
        />
      </div>

      {/* botão embaixo */}
      <div className="copy-actions">
        <button
          type="button"
          className="btn btn-outline btn-compact"
          onClick={copy}
          disabled={!pix.payload}
          title="Copiar código Pix"
        >
          {copied ? "Copiado!" : "Copiar"}
        </button>
      </div>

      <small className="muted">
        Pague pelo app do seu banco usando o QR Code ou cole o código acima.
      </small>
    </div>
  </div>

  
)}

        {step === "success" && (
          <div className="success-box">
            <div className="success-icon">✓</div>
            <h3>Pagamento confirmado!</h3>
            <p>Tudo certo. Em instantes você receberá a confirmação no sistema.</p>
          </div>
        )}
      </div>

{step === "paying" && (
  <div className="right-note">
    <small className="muted">
      Assim que o pagamento for confirmado você será redirecionado para a tela de
      <strong> login</strong> e já poderá acessar o <strong>Nórea CRM</strong>.
    </small>
  </div>
)}

    </div>
    
  );
}
